<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'activityList' }">活动分类</router-link>
                </li>
                <li class="active">(添加/修改)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="activity" :rules="rules">
                <el-form-item label="主标题:" prop="mainTitle">
                    <el-input v-model="activity.mainTitle" placeholder="请输入主标题"></el-input>
                </el-form-item>
                <el-form-item label="副标题:" prop="subTitle">
                    <el-input v-model="activity.subTitle" placeholder="请输入副标题"></el-input>
                </el-form-item>
                <el-form-item label="活动图片:">
                    <el-upload :action="serverUrl + '/file/upload'" :on-success="uploadSuccess" :limit="1">
                        <el-button size="small" type="primary">上传</el-button>
                        <div slot="tip" class="el-upload__tip">请上传400*100的图片</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="位置:">
                    <el-input type="number" v-model="activity.sequence" placeholder="请输入位置"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveActivity" size="small">保存</el-button>
                    <el-button @click="resetForm('formName')" size="small">重置</el-button>
                    <el-button @click="$router.back(-1)" size="small">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activity: {},
            rules: {},
            serverUrl:config.hostUrl
        }
    },
    created() {
        var _this = this;
        _this.activityId = _this.$route.query.activityId;
        if (_this.activityId) {
            _this.$common.ajaxRequest({
                url: '/activity/detailActivity',
                data: {
                    activityId: _this.activityId
                },
                success(response) {
                    _this.activity = response.item || {}
                }
            })
        }
    },
    methods: {
        uploadSuccess(res, file) {
            let _this = this;
            _this.activity.iconPath = res.msg;
        },
        saveActivity() {
            var _this = this;
            _this.$common.ajaxRequest({
                url: '/activity/saveActivity',
                data: _this.activity,
                success(response) {
                    _this.$message({
                        message: '保存成功',
                        type: 'success',
                        duration: 1000,
                        onClose: function() {
                            _this.$router.push({ name: 'activityList' });
                        }
                    });
                }
            })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
}
</script>